export default "__VITE_ASSET__Bl_OIjqK__"